var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8997 18.0021C14.2317 19.4416 12.068 20.3105 9.70364 20.3105C4.42807 20.3105 0.151367 15.9842 0.151367 10.6474C0.151367 5.31054 4.42807 0.984192 9.70364 0.984192C12.068 0.984192 14.2317 1.85315 15.8997 3.29259C17.5677 1.85315 19.7314 0.984192 22.0958 0.984192C27.3713 0.984192 31.648 5.31054 31.648 10.6474C31.648 15.9842 27.3713 20.3105 22.0958 20.3105C19.7314 20.3105 17.5677 19.4416 15.8997 18.0021Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8994 18.0024C17.9534 16.23 19.2559 13.5926 19.2559 10.6474C19.2559 7.70224 17.9534 5.0648 15.8994 3.2924C17.5674 1.85311 19.731 0.984253 22.0952 0.984253C27.3708 0.984253 31.6475 5.3106 31.6475 10.6474C31.6475 15.9842 27.3708 20.3106 22.0952 20.3106C19.731 20.3106 17.5674 19.4417 15.8994 18.0024Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8992 18.0021C17.953 16.2297 19.2554 13.5923 19.2554 10.6473C19.2554 7.70227 17.953 5.06494 15.8992 3.29254C13.8453 5.06494 12.543 7.70227 12.543 10.6473C12.543 13.5923 13.8453 16.2297 15.8992 18.0021Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard-logo.53af0d1e0086c121ce7bd2f427c429f9.svg";
export { ForwardRef as ReactComponent };